module.exports = __webpack_public_path__ + "img/twitter.22a725f.svg?v=1764903765445";